import script from "./SSNField.vue?vue&type=script&setup=true&lang=js"
export * from "./SSNField.vue?vue&type=script&setup=true&lang=js"

import "./SSNField.vue?vue&type=style&index=0&id=1bce3e56&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bce3e56"]])

export default __exports__